import React from 'react';
import { Route, Routes, Navigate, useParams } from 'react-router-dom';
import {
  ManualAlertEvents,
  ManualAlertSummary,
  PreManualAlertDiagnostics,
  AlertDiagnostics,
} from './manualAlert';
import { ManualBase } from './base';

const AlertSummary = ManualBase(ManualAlertSummary);
const AlertEvents = ManualBase(ManualAlertEvents);

// passing key to do a full remount
// to intiate a new jotai store to have clean state between multiple temp dashboards of same type
const AlertDiagnosticsDrilldown = (props) => {
  const { id = -1 } = useParams();
  return <AlertDiagnostics key={id} {...props} />;
};

const Alert = () => {
  return (
    <Routes>
      <Route path={`/manual/summary`} element={<AlertSummary />} />
      <Route path={`/manual/events`} element={<AlertEvents />} />
      <Route path={`/manual/diagnostics`} element={<PreManualAlertDiagnostics />} />
      <Route path={`/manual`} element={() => <Navigate to={`/manual/summary`} replace />} />
      <Route path={`/diagnostics/:id`} element={<AlertDiagnosticsDrilldown />} />
    </Routes>
  );
};

export default Alert;
